<script setup lang="ts">
/**
 * Measure guide — Figma `Sizes · components` 06: the body with the line of the
 * field in focus (weight and foot length have their own pictures) and a title
 * + one sentence on how to take it. With no field in focus: "How to measure".
 */
import { computed } from 'vue'
import {
  fairProfileV2GuideFigure,
  type FairProfileV2Body,
  type FairProfileV2MeasureKey,
} from './fair-profile-v2-measure.data'

interface FairProfileV2MeasureGuideProps {
  body: FairProfileV2Body
  active?: FairProfileV2MeasureKey | null
  title: string
  text: string
}

const props = withDefaults(defineProps<FairProfileV2MeasureGuideProps>(), {
  active: null,
})

const figure = computed(() => fairProfileV2GuideFigure(props.body, props.active))

function box(overlay: { left: number; top: number; width: number; height: number }) {
  return {
    left: `${overlay.left}px`,
    top: `${overlay.top}px`,
    width: `${overlay.width}px`,
    height: `${overlay.height}px`,
  }
}
</script>

<template>
  <div
    class="fair-profile-v2-measure-guide"
    aria-live="polite"
  >
    <div class="fair-profile-v2-measure-guide__holder">
      <div
        class="fair-profile-v2-measure-guide__figure"
        :class="`fair-profile-v2-measure-guide__figure--${figure.kind}`"
        aria-hidden="true"
      >
        <img
          class="fair-profile-v2-measure-guide__image"
          :src="figure.src"
          alt=""
        >
        <img
          v-if="figure.kind !== 'weight' && figure.overlay"
          class="fair-profile-v2-measure-guide__line"
          :src="figure.overlay.src"
          :style="box(figure.overlay)"
          alt=""
        >
      </div>
    </div>
    <div class="fair-profile-v2-measure-guide__text">
      <p class="fair-profile-v2-measure-guide__title">
        {{ title }}
      </p>
      <p class="fair-profile-v2-measure-guide__body">
        {{ text }}
      </p>
    </div>
  </div>
</template>
